import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { Cabinet } from 'projects/app-misc/src/app/modules/cabinets/data/cabinet';
import { PartLabel } from 'projects/cart-tv/src/app/data/cart.sevice';

@JsonObject('model.Tray')
export class Tray extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Number, 'cartId')
  cartId: number;

  @JsonProperty(String, 'number')
  number: string;

  @JsonProperty(String, 'status')
  type: string;

  @JsonProperty(Number, 'totalQty')
  totalQty: number;

  @JsonProperty(Number, 'filledQty')
  filledQty: number;

  @JsonProperty([Cabinet], 'cabinets')
  cabinets: Cabinet[];

  partLabel: PartLabel;

}
